import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/pro-solid-svg-icons';
import { CharlieButton } from '@ver.id/libs.ui.charlie';
import { useTranslation } from '../../i18n/i18n';
import { type AbortVariant } from '../../types';
import { getAbortVariant, abortVariantConfig } from '../../utils/abortVariants';

type Props = {
  errorCode?: number;
  variant?: AbortVariant;
  onReject?: () => void;
  onRestart?: () => void;
  onBack?: () => void;
  /** Button direction: column on mobile, row on desktop */
  buttonDirection?: 'col' | 'row';
};

export default function AbortContent({
  errorCode,
  variant: variantProp,
  onReject,
  onRestart,
  onBack,
  buttonDirection = 'row',
}: Props) {
  const { t } = useTranslation();
  const variant = variantProp ?? getAbortVariant(errorCode);
  const config = abortVariantConfig[variant];

  return (
    <div className="flex flex-1 items-center justify-center w-full">
      <div className="flex flex-col items-center gap-4 text-center max-w-lg w-full">
        <div
          className={`flex items-center justify-center size-12 rounded-full ${config.bgClass}`}
        >
          <FontAwesomeIcon
            icon={config.icon}
            className={`size-7 ${config.iconClass}`}
          />
        </div>
        <h2 className="text-2xl font-semibold text-foreground">
          {t(config.titleKey)}
        </h2>
        <p className="text-sm text-muted-foreground">{t(config.subtitleKey)}</p>
        <div
          className={`flex ${buttonDirection === 'col' ? 'flex-col' : 'flex-row'} gap-3 mt-2 w-full`}
        >
          {onReject && (
            <CharlieButton
              variant="outline"
              className="flex-1"
              onClick={onReject}
            >
              {t('abort.leave')}
            </CharlieButton>
          )}
          {config.showRestart && onRestart && (
            <CharlieButton className="flex-1" onClick={onRestart}>
              <FontAwesomeIcon icon={faArrowsRotate} className="size-4 mr-2" />
              {t(config.restartKey)}
            </CharlieButton>
          )}
          {variant === 'appUnavailable' && onBack && (
            <CharlieButton className="flex-1" onClick={onBack}>
              {t('abort.selectDifferentApp')}
            </CharlieButton>
          )}
        </div>
      </div>
    </div>
  );
}
